import { type RcOptions } from '../types/RcOptions.ts'

/** TypeScript helper for the .ncurc config file. Similar to Vite's and ESLint's `defineConfig` helpers. */
function defineConfig(config: RcOptions) {
  return config
}

export default defineConfig
